export const dataFeatures = [
    {
      id: 1,
      imgSrc:
        "https://images.unsplash.com/photo-1533115149875-0a1c8612f726?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1470&q=80",
      title: "Meal Planning",
      desc:
        "Easily generate and save meal plans for the week. Our advanced algorithm takes your dietary preferences and restrictions into account to create a personalized plan just for you.",
      btn: "Start Planning",
      href: "/meal",
    },
    {
      id: 2,
      imgSrc:"https://images.unsplash.com/photo-1528712306091-ed0763094c98?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2840&q=80",

        title: "Recipe Management",
      desc:
        "Manage all of your favorite recipes in one place. Add new recipes, edit existing ones, and organize them by category for easy access.Look for Steps , accurate ingredients and Nutritional information.",
      btn: "Manage Recipes",
      href: "/recipe",
    },
    {
      id: 3,
      imgSrc:
        "https://images.pexels.com/photos/2599244/pexels-photo-2599244.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2",
      title: "AI Chat Bot",
      desc:
        "Got a question about your diet or health? Our AI chat bot is here to help. Get personalized answers and recommendations from our advanced AI technology.",
      btn: "Chat Now",
      href: "/chatBot",
    },
    {
      id: 4,
      imgSrc:
        "https://images.pexels.com/photos/5327921/pexels-photo-5327921.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2",
      title: "Live Dietician Support",
      desc:
        "Need more personalized support? Our team of experienced dieticians are available to help. Schedule a live chat or video call to get one-on-one advice and guidance.",
      btn: "Get Support",
      href: "/support",
    },
  ];
  